import { axios } from './config';

// 部署列表接口
export function deployList(params) {
  return axios.get('/activity/list_all', params, true)
}

// 部署接口
export function deploy(params) {
  return axios.post('/activity/deploy', params, true)
}

// 取消部署
export function cancelDeploy(params) {
  return axios.post('/activity/delete', params, true)
}

// 工作流程 - 模板列表
export function getModalList(params) {
  return axios.post('/activity/query', params, true)
}

// 工作流程 - 发起申请（保存）
export function InitiateApplication(params) {
  return axios.post('/activity/start', params, true)
}

// 工作流 - 历史历程和进度（记录）
export function getRescord(params) {
  return axios.post('/activity/findHistoryTask', params, true)
}

// 待办列表
export function getNeedDealWithList(params) {
  return axios.post('/activity/getMyTask', params, true)
}

// 提交记录
export function submitMyTask(params) {
  return axios.post('/activity/submitMyTask', params, true)
}